import Navbar from "../components/Navbar"
import Main from "../components/Main"
import Product from "../components/Products"
import Footer from "../components/Footer"

function Home() {
  return (
    <>
      <Navbar/>
      <Main />
      <Product />
      <Footer/>
    </>
  )
}

export default Home;